<div class="flex overflow-hidden">
    <aside [id]="sidebarId"
        class="flex z-30 fixed h-screen lg:w-80 w-[89px] p-3 bg-white border-r border-r-stone-200 border-dashed transition-width duration-500 ease-in"
        aria-label="Sidebar">
        <nav class="w-full h-full" aria-label="Main navigation" role="navigation">
            <div class="h-full top-0 relative">
                <div (mouseover)="toggleButtonVisibility(true)" (click)="copyEmail()"
                    class="cursor-pointer w-full p-2 h-16 border rounded-xl border-r-stone-200 overflow-hidden">
                    <div class="relative group flex w-full h-full rounded-md">
                        <img class="rounded-md" [src]="picture" alt="user photo">
                        <div class="px-3 flex-grow overflow-hidden">
                            <h6 class="text-base font-sans font-medium truncate" *ngIf="auth0.user$ | async as user">{{
                                user.name
                                }}</h6>
                            <p class="text-xs truncate" *ngIf="auth0.user$ | async as user">{{ user.email }}</p>
                        </div>
                        <!-- Desfoque de Fundo no Hover -->
                        <div
                            class="rounded-md absolute bg-white inset-0 bg-opacity-60 group-hover:backdrop-blur-xl transition-opacity duration-300 ease-linear opacity-0 group-hover:opacity-100 pointer-events-none">
                        </div>
                        <!-- Texto visível no hover -->
                        <div
                            class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-linear pointer-events-none">
                            <span class="flex text-sm font-medium z-10">
                                <svg *ngIf="!copyUserEmail" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mx-2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z" />
                                </svg>
                                <svg *ngIf="copyUserEmail" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mx-2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" />
                                </svg>

                                {{ messageForCopyEmail }}
                            </span>
                        </div>
                    </div>
                </div>

                <div *ngIf="buttonVisibility" class="mt-2 w-full">
                    <button (click)="logoutAuth0()"
                        class="animate-fade-down animate-once animate-duration-500 animate-ease-in-out bg-red-500 disabled:bg-red-600 font-normal hover:bg-red-700 px-3 py-2 w-full rounded-lg text-center text-sm text-white transition-all">
                        Sair da conta
                    </button>
                </div>

                <div id="search" class="lg:block hidden mt-10">
                    <form>
                        <label for="default-search"
                            class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Pesquisar</label>
                        <div class="relative">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                </svg>
                            </div>
                            <input type="search" id="default-search"
                                [(ngModel)]="searchTerm"
                                [ngModelOptions]="{standalone: true}"
                                (input)="onSearchMenu(searchTerm)"
                                class="block w-full p-4 pl-10 pr-20 text-sm text-gray-900 border border-gray-300 rounded-xl bg-gray-50 focus:ring-stone-500 focus:border-stone-500"
                                placeholder="Pesquisar" required autocomplete="off">
                            <div class="absolute inset-y-0 right-0 flex items-center pr-3 space-x-1">
                                <kbd
                                    class="px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg dark:bg-gray-600 dark:text-gray-100 dark:border-gray-500">Ctrl</kbd>
                                <span class="text-xs font-semibold">+</span>
                                <kbd
                                    class="px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg dark:bg-gray-600 dark:text-gray-100 dark:border-gray-500">K</kbd>
                            </div>
                        </div>
                    </form>
                </div>

                <ul id="items-menu"
                    class="lg:block hidden h-3/4 scrollbar-thin overflow-auto scrollbar-thumb-transparent scrollbar-track-transparent pb-2 pt-1 mt-10">
                    @for (itemMenu of (filteredMenu.length > 0 ? filteredMenu : menu); track $index) {
                    <li class="mb-2">
                        <div [routerLink]="itemMenu.url"
                            class="group flex hover:bg-gray-950 cursor-pointer items-center p-1 h-12 rounded-xl mb-2 w-full transition-all duration-200"
                            (mouseenter)="onHoverItem(itemMenu, true)" (mouseleave)="onHoverItem(itemMenu, false)"
                            [attr.aria-controls]="itemMenu.subItemMenu ? itemMenu.id : null" 
                            [attr.data-collapse-toggle]="itemMenu.subItemMenu ? itemMenu.id : null">
                            <div class="flex-none w-14">
                                <!-- <svg [class]="itemMenu.isHovered ? 'w-5 h-5 group-hover:text-white' : 'w-5 h-5'">
                                </svg> -->
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor"
                                    class="ml-2 w-6 h-6 group-hover:text-white">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                                </svg>
                            </div>
                            <div class="grow">
                                <a class="ml-4 group-hover:text-white text-base font-medium" [routerLink]="">{{
                                    itemMenu.nameMainItemMenu
                                    }}</a>
                            </div>
                            <div *ngIf="!itemMenu.url" class="flex justify-center w-14">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-5 h-5 group-hover:text-white">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                                </svg>
                            </div>
                        </div>
                        <ul *ngIf="itemMenu.subItemMenu" [id]="itemMenu.id" 
                            [ngClass]="{'pb-1 pt-1 hidden': filteredMenu.length === 0 , 'pb-1 pt-1': filteredMenu.length > 0}">
                            <ol class="ml-5 mt-2 relative border-s border-gray-200">
                                @for (subItemMenu of itemMenu.subItemMenu; track $index) {
                                <!-- @if (subItemMenu.isVisible) { -->
                                <li *ngIf="subItemMenu.isVisible" routerLinkActive="active-link" [routerLink]="subItemMenu.url"
                                    class="group hover:cursor-pointer px-2 mb-1 ms-4">
                                    <div
                                        class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700">
                                    </div>
                                    <h3
                                        class="group-hover:text-blue-500 text-sm font-semibold text-gray-900 dark:text-white">
                                        {{
                                        subItemMenu.name
                                        }}</h3>
                                    <p class="mb-4 text-xs font-normal text-gray-500 dark:text-gray-400">{{
                                        subItemMenu.description }}</p>
                                </li>
                                <!-- } -->
                                }
                            </ol>
                        </ul>
                    </li>
                    }
                </ul>

                <div (click)="toggleSidebarId()"
                    class="absolute bg-white bottom-0 left-0 z-50 w-full flex justify-end items-center space-x-2 group cursor-pointer">
                    @if (!isColapseMenu) {
                    <p class="text-xs text-slate-500 group-hover:text-blue-500 font-semibold">
                        Colapsar menu
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-5 h-5 text-slate-500 group-hover:text-blue-500">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-5 h-5 cursor-pointer text-slate-500 hover:text-blue-500">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
                    </svg>
                    }
                </div>
            </div>
        </nav>
    </aside>

    <div id="main-content" [ngClass]="{'margin-left-5rem-important': isColapseMenu}"
        class="h-screen w-full relative overflow-y-auto lg:ml-80 ml-20">
        <main>
            <ng-content></ng-content>
        </main>
    </div>
</div>